var _rect, _path, _path2, _path3, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIrLiftFloorsMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3893 14.1323H13.1284C13.1284 11.8714 15.3893 12.4366 15.3893 10.741C15.3893 9.89314 14.2589 9.32792 13.1284 10.1757",
    stroke: "white",
    strokeWidth: 1.32727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1769 14.1322L9.13932 14.132L9.13932 9.81568",
    stroke: "white",
    strokeWidth: 1.32727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42969 7.97713L6.42969 16.0231C6.42969 16.7068 6.98389 17.261 7.66753 17.261L16.3325 17.261C17.0161 17.261 17.5703 16.7068 17.5703 16.0231L17.5703 7.97713C17.5703 7.29349 17.0161 6.73928 16.3325 6.73928L7.66753 6.73928C6.98389 6.73929 6.42969 7.29349 6.42969 7.97713Z",
    stroke: "white",
    strokeWidth: 1.32727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2612,
    y: 4.66284,
    width: 5.20308,
    height: 5.09349,
    rx: 0.995455,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8123 5.62218V8.66284H15.1694V5.62218H15.8123ZM16.3412 8.66284V5.62218H17.5408C17.7705 5.62218 17.9664 5.66325 18.1288 5.74541C18.2921 5.82657 18.4163 5.94188 18.5014 6.09134C18.5875 6.23981 18.6306 6.41451 18.6306 6.61544C18.6306 6.81736 18.5871 6.99107 18.4999 7.13657C18.4128 7.28108 18.2866 7.39194 18.1214 7.46914C17.957 7.54635 17.7581 7.58495 17.5245 7.58495H16.7213V7.06827H17.4206C17.5433 7.06827 17.6453 7.05145 17.7264 7.0178C17.8076 6.98414 17.868 6.93366 17.9076 6.86636C17.9481 6.79905 17.9684 6.71541 17.9684 6.61544C17.9684 6.51448 17.9481 6.42936 17.9076 6.36007C17.868 6.29079 17.8071 6.23833 17.7249 6.2027C17.6438 6.16607 17.5413 6.14776 17.4176 6.14776H16.9841V8.66284H16.3412ZM17.9833 7.2791L18.739 8.66284H18.0293L17.2899 7.2791H17.9833Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrLiftFloorsMarker);
export default __webpack_public_path__ + "static/media/IrLiftFloorsMarker.155afda281529326ccca64e02cdff916.svg";
export { ForwardRef as ReactComponent };